import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useT } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { PageHeader } from "@/components/StatCard";
import Seo from "@/components/Seo";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { ChevronLeft } from "lucide-react";

import DailyPlansTab from "@/pages/coach/plans/DailyPlansTab";
import WeeklyPlansTab from "@/pages/coach/plans/WeeklyPlansTab";
import BreathProgramsTab from "@/pages/coach/plans/BreathProgramsTab";

export default function Plans() {
  const { user } = useAuth();
  const t = useT();
  usePageMeta(t("pl.meta_title"));

  if (user && user.role !== "coach") return <Navigate to="/app/circles" replace />;

  return (
    <div data-testid="coach-plans-page">
      <Seo title={t("pl.seo")} noindex />
      <Link to="/app/coach" className="mb-3 inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground" data-testid="plans-back">
        <ChevronLeft className="h-4 w-4" /> {t("pl.back")}
      </Link>
      <PageHeader eyebrow={t("pl.eyebrow")} title={t("pl.title")} subtitle={t("pl.subtitle")} />

      <Tabs defaultValue="daily" className="mt-6">
        <TabsList className="mb-4 flex h-auto w-full flex-wrap justify-start gap-1 bg-secondary/60 p-1">
          <TabsTrigger value="daily" data-testid="pl-tab-daily">{t("pl.tab_daily")}</TabsTrigger>
          <TabsTrigger value="weekly" data-testid="pl-tab-weekly">{t("pl.tab_weekly")}</TabsTrigger>
          <TabsTrigger value="programs" data-testid="pl-tab-programs">{t("pl.tab_programs")}</TabsTrigger>
        </TabsList>
        <TabsContent value="daily"><DailyPlansTab /></TabsContent>
        <TabsContent value="weekly"><WeeklyPlansTab /></TabsContent>
        <TabsContent value="programs"><BreathProgramsTab /></TabsContent>
      </Tabs>
    </div>
  );
}
